/**
 * toast.js — global toast dispatcher (god-file decomposition).
 * Verbatim move from AdminScreen.jsx; fires the window 'toast' CustomEvent.
 */

export const showToast = (text, type = 'info') => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('toast', { detail: { type, text } }));
  }
};
